module.exports = __webpack_public_path__ + "static/media/insta_btn.641a44e2.svg";